import styles from './styles.module.css';

import posteiLogoText from '../../assets/logos/xama-logo-branco.png';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { CancelAccountService } from '../../services';
import { notifyErrorCustom, notifySuccessCustom } from '../../utils/notify';
import { motion } from 'framer-motion';

function CancelPlan() {
  const navigation = useNavigate();
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleNavigate = (route) => {
    navigation(`${route}`);
  };

  const handleCancelPlanAccount = async (code) => {
    if (!code) {
      notifyErrorCustom(<>Preencha o campo com o código enviado por e-mail.</>);
      return;
    }

    const response = await CancelAccountService.confirmCancelPlan(code);

    if (response?.data?.success && response?.responseStatus === 200) {
      notifySuccessCustom(
        'Cancelamento da assinatura agendado com sucesso para o fim do ciclo atual.',
      );
      handleNavigate('/SignIn');
      return;
    }

    const errorMessage =
      response?.response?.data?.error?.message ||
      response?.response?.data?.message;

    if (errorMessage?.includes('expirado') || errorMessage?.includes('utilizado')) {
      notifyErrorCustom(
        <>
          Código invalido. <br /> O código fornecido está expirado ou já foi utilizado.
        </>,
      );
      return;
    }

    notifyErrorCustom(
      <>
        Código invalido. <br /> Por favor verifique o código e tente novamente.
      </>,
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{ width: '100%', height: '100%' }}
    >
      <div className={styles.page}>
        <div className={styles.container_form}>
          <form>
            <div className={styles.form_header}>
              <div className={styles.logo}>
                <img
                  src={posteiLogoText}
                  alt="posteiLogoText"
                  style={{ height: 34 }}
                />
              </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.form_body}>
              <h1>Cancelamento.</h1>
              <div className={styles.form_body_title}>
                <p>
                  Atenção: Ao prosseguir, sua assinatura será cancelada ao final
                  do ciclo atual.
                </p>
                <p>
                  Utilize o código recebido por e-mail e clique em prosseguir.
                </p>
              </div>

              <div className={styles.form_body_content}>
                <input
                  className={styles.input}
                  placeholder="Preencha com o código recebido por e-mail"
                  value={inputValue}
                  onChange={handleInputChange}
                ></input>
              </div>
            </div>

            <div className={styles.form_footer}>
              <button
                className={styles.button_cancel}
                onClick={() => handleNavigate('/')}
              >
                Cancelar
              </button>
              <button
                className={styles.button_register}
                onClick={(e) => {
                  e.preventDefault();
                  handleCancelPlanAccount(inputValue);
                }}
              >
                Prosseguir
              </button>
            </div>
          </form>
        </div>
      </div>
    </motion.div>
  );
}

export default CancelPlan;
